// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2E4053', // #2E4053 Your primary color
    },
    secondary: {
      main: '#50728C', // #50728C Your secondary color
    },
    text: { // Add this to customize text colors
      primary: '#333',  // #333 Dark gray for most text
      secondary: '#666', // Lighter gray for less important text
      disabled: '#999', // Even lighter for disabled text
    },
    background: {
      paper: '#fff', // Background for menu items (usually white)
    }
  },
  typography: { // Add this typography section
    fontFamily: [
      'Roboto', // Your primary font
      'Arial',   // Fallback font
      'sans-serif', // Generic fallback
    ].join(','),
    // You can also customize specific typography variants:
    h1: {
        fontSize: '3rem',
        // fontWeight: 700, // Example
    },
    body1: {
        fontSize: '1rem',
    },
    // ... other variants ...
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#2E4053', // #2E4053
          '&.Mui-checked': {
            color: '#2E4053', // #2E4053
          },
          '&.Mui-disabled': {
            color: '#cccccc', // #cccccc
          },
        },
      },
    },
    MuiOutlinedInput: { // Styles for the outlined input (the box)
      styleOverrides: {
        root: {
          color: '#2E4053',
          '& .MuiOutlinedInput-notchedOutline': { // Targets the outline
            borderColor: '#50728C', // Default border color
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2E4053', // Border color on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2E4053', // Border color when focused
            borderWidth: '2px', // Thicker border on focus
          },
        },
      },
    },
    MuiInputLabel: {  // Styles for the label ("Select content type")
      styleOverrides: {
        root: {
          color: '#50728C', // Label color
          '&.Mui-focused': {
            color: '#2E4053', // Label color when focused
          },
        },
      },
    },
    MuiSelect: { // Styles for the select component itself
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent', // Prevent blue background on focus
          },
        },
        icon: {  // Styles for the dropdown arrow icon
          color: '#2E4053', // Icon color
        },
      }
    },
    MuiMenuItem: { // Styles for the individual menu items
        styleOverrides: {
          root: {
            color: '#2E4053',
            '&:hover': {
                backgroundColor: '#f0f0f0', // #f0f0f0 Light gray on hover
                color: '#2E4053',       // #2E4053 Text color on hover
            },
            '&.Mui-selected': { // Currently selected item
                backgroundColor: '#e0e0e0', // #e0e0e0
                color: '#2E4053',
                '&:hover': {
                    backgroundColor: '#d0d0d0', // #d0d0d0 Slightly darker on hover
                }
            }
          },
        },
    },
    MuiButton: { // Add this to customize Button styles
      styleOverrides: {
        outlined: { // Target the outlined variant
          '&:hover': {  // Target the hover state
            backgroundColor: '#f0f0f0', // Example hover styles
            color: '#2E4053',
            borderColor: '#2E4053', // #2E4053
          },
        },
      },
    },
    MuiFormControlLabel: { // Add this to style FormControlLabel
      styleOverrides: {
        label: {  // Target the label within FormControlLabel
          color: '#2E4053', // Your desired label color
          '&.Mui-disabled': { // Style when disabled
            color: '#999999',
          },
        },
      },
    },
  },
});

export default theme;